import styled from 'styled-components';

export default styled.div`
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;

  .Form {
    &-title {
      padding: 0px 20px;
      line-height: 1.5;
      text-align: center;
      color: var(--text-color-2);
      font-size: 18px;
      margin-bottom: 2rem;
    }

    &-blockTitle {
      padding: 0px 20px;
      line-height: 1.5;
      text-align: center;
      color: var(--text-color-2);
      font-size: 15px !important;
      font-style: italic;
      margin-bottom: 2rem;
    }

    &-row {
      display: flex;
      margin: 0 -1.5rem 1rem -1.5rem;
    }

    &-col {
      padding: 0 1.5rem;
      flex: 1;
    }

    &-group {
      width: 100%;
      margin-bottom: 1rem;
    }

    &-subtitle {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 7px;
      margin-bottom: 1.5rem;

      h3 {
        font-weight: 400;
        font-size: 18px;
        color: var(--text-color-2);
      }
    }
  }
`;
